import { createContext } from 'react';
import { Agent } from '../Providers/DashboardProvider';
import {
  IUpdateAssistant,
  IUpdateEventsFunction,
  SystemPromptData,
} from '../schemas/apis/interface';

interface DashboardContextType {
  selectedAssistant: Agent | null;
  setSelectedAssistant: (assistant: Agent | null) => void;
  selectedAssistantId: string | null;
  setSelectedAssistantId: (id: string | null) => void;
  updateAssistantEvent: (
    eventName: string,
    eventValue: string,
    active: boolean
  ) => void;
  updateEventFunction: (values: IUpdateEventsFunction) => Promise<void>;
  isUpdateEventFunctionPending: boolean;
  isUpdateSystemPromptPending: boolean;
  updateAssistantSystemPrompt: (values: IUpdateAssistant) => Promise<void>;
  localValues: SystemPromptData;
  setLocalValues: (data: SystemPromptData) => void;
  handleInputChange: (key: keyof SystemPromptData, value: string) => void; // ✅ Fixed typo and corrected function signature
}

export const DashboardContext = createContext<DashboardContextType | undefined>(
  undefined
);
